import { render, staticRenderFns } from "./returnAndExchangeEditor.vue?vue&type=template&id=04ec2494&scoped=true&"
import script from "./returnAndExchangeEditor.vue?vue&type=script&lang=js&"
export * from "./returnAndExchangeEditor.vue?vue&type=script&lang=js&"
import style0 from "./returnAndExchangeEditor.vue?vue&type=style&index=0&id=04ec2494&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ec2494",
  null
  
)

export default component.exports